"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _excluded = ["tool", "ScriptComponent", "toolPath", "filename", "options", "eventHandler", "data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var scriptLoader = function scriptLoader(_ref) {
  var tool = _ref.tool,
    _ref$ScriptComponent = _ref.ScriptComponent,
    ScriptComponent = _ref$ScriptComponent === void 0 ? 'script' : _ref$ScriptComponent,
    toolPath = _ref.toolPath,
    filename = _ref.filename,
    options = _ref.options,
    eventHandler = _ref.eventHandler,
    data = _ref.data,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var s = document.createElement('script');
  s.src = "".concat(options.domain, "/").concat(toolPath).concat(filename);
  s.async = true;
  s.defer = true;
  s.id = "".concat((options === null || options === void 0 ? void 0 : options.id) || tool, "-script");
  var loadData = function loadData() {
    s.dispatchEvent(new CustomEvent('data', {
      detail: {
        data: data
      },
      props: _objectSpread({}, props)
    }));
  };
  s.addEventListener('message', function (e) {
    return eventHandler(e.detail);
  });
  s.addEventListener('load', loadData);
  s.addEventListener('requestData', loadData);
  Object.keys(props).forEach(function (key) {
    var filteredKey = key.startsWith('data-') ? key.slice(5) : key;
    s.setAttribute("data-".concat(filteredKey), props[key]);
  });
  return s;
};
var _default = exports["default"] = scriptLoader;